// components/tabs/IsothermalTab.jsx
// 等温三元相图

import TernaryDiagram from '../viz/TernaryDiagram';
import { useSolPred } from '../../hooks/useSolPredStore';

export default function IsothermalTab() {
  const {
    selectedSystem, temperature,
    dataPoints, predictions, invariantPoints, phaseList,
    showPrediction, showRegions, setShowRegions,
    hoveredPoint, setHoveredPoint,
    selectedPhase, selectedPoint, setSelectedPoint,
    liveResult, liveW1, liveW2,
  } = useSolPred();

  return (
    <div className="canvas-card full fade-in">
      <div className="canvas-header">
        <div>
          <div className="canvas-title">等温三元相图 · Isothermal Ternary</div>
          <div className="canvas-subtitle">
            T = {temperature}°C · {dataPoints.length} 点 · {predictions.length} 条溶解度曲线
          </div>
        </div>
        <div className="canvas-tools">
          <button
            className={`tool-btn ${showRegions ? 'active' : ''}`}
            onClick={() => setShowRegions(v => !v)}
          >相区填色</button>
          <button className="tool-btn">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" />
            </svg>
            导出 SVG
          </button>
        </div>
      </div>
      <div className="diagram-box">
        <div className="diagram-svg-wrap">
          <TernaryDiagram
            dataPoints={dataPoints}
            predictions={predictions}
            invariantPoints={invariantPoints}
            labels={selectedSystem.components}
            showPrediction={showPrediction && selectedSystem.hasModel}
            showRegions={showRegions && selectedSystem.hasModel}
            hoveredPoint={hoveredPoint}
            onHoverPoint={setHoveredPoint}
            selectedPhase={selectedPhase}
            phaseList={phaseList}
            livePoint={liveResult ? { w1: liveW1, w2: liveW2 } : null}
            selectedPointId={selectedPoint?.id}
            onSelectPoint={(pt) => setSelectedPoint({ kind: 'experimental', ...pt })}
            onSelectCurvePoint={(cp) => setSelectedPoint({
              kind: cp.isInvariant ? 'invariant' : 'prediction',
              id: `curve-${cp.segIdx}-${cp.idx}-${temperature}`,
              w1: cp.w1, w2: cp.w2,
              ww: cp.ww !== undefined ? cp.ww : 1 - cp.w1 - cp.w2,
              temp: temperature,
              solidPhase: cp.phaseLabel,
              color: cp.color,
              source: cp.isInvariant ? 'PC-CVAE 不变点' : 'PC-CVAE 预测曲线',
              uncertainty: 0.005,
            })}
          />
        </div>
      </div>
    </div>
  );
}
